import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProtection = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "22px",
	height: "24px",
	viewBox: "0 0 22 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.2146 3.3589C21.1724 3.04946 20.9542 2.79493 20.6593 2.71127L11.206 0.0287059C11.0712 -0.00956863 10.9289 -0.00956863 10.794 0.0287059L1.34075 2.71127C1.04579 2.79493 0.827601 3.04936 0.785377 3.3589C0.730547 3.7612 -0.520288 13.2667 2.68802 17.9953C5.89253 22.7184 10.6199 23.9287 10.8195 23.978C10.8789 23.9926 10.9393 23.9998 11 23.9998C11.0607 23.9998 11.1211 23.9925 11.1805 23.978C11.3802 23.9287 16.1076 22.7184 19.312 17.9953C22.5203 13.2668 21.2695 3.76131 21.2146 3.3589ZM17.0961 8.90829L10.6481 15.4878C10.498 15.6409 10.3013 15.7176 10.1046 15.7176C9.90792 15.7176 9.71114 15.641 9.5611 15.4878L5.57432 11.4198C5.43012 11.2727 5.34916 11.0732 5.34916 10.8652C5.34916 10.6572 5.43022 10.4577 5.57432 10.3106L6.36591 9.5029C6.66609 9.19671 7.1528 9.1966 7.45288 9.5029L10.1046 12.2087L15.2176 6.99132C15.3617 6.84418 15.5572 6.76157 15.7611 6.76157C15.9649 6.76157 16.1604 6.84418 16.3045 6.99132L17.0961 7.79906C17.3963 8.10536 17.3963 8.60199 17.0961 8.90829Z",
		fill: "#FBBF00"
	})
});
export default SvgProtection;
